// Which pages a role sees. Warehouse receivers see only the pages that name them (the receiving
// screen); everyone else sees every page except those limited to other roles.
import type { Role } from "../../../shared/mutations.ts";
import type { NavDef } from "../nav.ts";

export const canSee = (route: Pick<NavDef, "roles">, role: Role | undefined) =>
  !!role && (role === "receiving" ? !!route.roles?.includes("receiving") : !route.roles || route.roles.includes(role));

/** Where a role starts: receivers go straight to receiving. */
export const homeFor = (role: Role | undefined) => (role === "receiving" ? "/receiving" : "/");
